export default function findFocusedRoute(state) {
    var current = state;
    var _current_index;
    while((current === null || current === void 0 ? void 0 : current.routes[(_current_index = current.index) !== null && _current_index !== void 0 ? _current_index : 0].state) != null){
        var _current_index1;
        current = current.routes[(_current_index1 = current.index) !== null && _current_index1 !== void 0 ? _current_index1 : 0].state;
    }
    var _current_index2;
    var route = current === null || current === void 0 ? void 0 : current.routes[(_current_index2 = current === null || current === void 0 ? void 0 : current.index) !== null && _current_index2 !== void 0 ? _current_index2 : 0];
    return route;
}
